import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0F1115] flex items-center justify-center">
        <span className="text-[#D5C0A1] text-xs tracking-[0.3em] uppercase">Cargando…</span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};
